
<template>
	<c-dialog ref="dialog" :title="'请选择需要'+title+'的仓库、'+title+'类型信息'" width="500" @resolve="resolve">
		<c-form ref="form" unit-width="100%">
			<c-form-item  :label="title+'仓库'" required>
				<c-select ref="warehouseInfo" v-model="warehouse_id" async @search="searchWarehouse" ></c-select>
			</c-form-item>
			<c-form-item :label="title+'类型'" required>
				<c-select ref="orderClassify" v-if="workType==4" v-model="order_classify" :options="stockinClassifyName"></c-select>
				<c-select ref="orderClassify" v-if="workType==5" v-model="order_classify" :options="stockoutClassifyName"></c-select>
				<c-select ref="orderClassify" v-if="workType==6" v-model="order_classify" :options="inventoryClassifyName"></c-select>
			</c-form-item>
			<c-form-item label="库存批次" v-if="workType == 4 && systemConfig.batch_stock == 1">
				<c-select name="batch_id" async v-model="batch_id" ref="batchSelect" @search="searchBatch" placeholder="不指定批次,将自动生成新库存批次"></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	name: 'storageInfoSelector',
	components: {},

	computed: {
		...mapState(['stockinClassifyName','stockoutClassifyName','inventoryClassifyName','stockClassifyName','systemConfig']),
	},

	data() {
		return {
			warehouse_id:0,
			order_classify:0,
			batch_id:0,
			placeholder: '请先选择仓库'
		}
	},

	props: {
		workType: [String, Number],
		title: String
	},

	methods: {
		/**
		 * @param exclude_process_ids  排除该工序不返回
		 */
		open() {
			this.$refs.form.clear();
			this.$refs.dialog.open();
		},

		/*******搜索【仓库】下拉框信息*****************/
		searchWarehouse(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/*******搜索【批次】下拉框信息*****************/
		searchBatch(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'BATCH',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		resolve(stop) {
			if (this.warehouse_id == 0){
				stop();
				this.$message({
					message: '请选择'+this.title+'仓库',
					type: 'warn'
				});
				return;
			}
			if (this.order_classify == 0){
				stop();
				this.$message({
					message: '请选择'+this.title+'类型',
					type: 'warn'
				});
				return;
			}
			var data = {};
			data.warehouse_id = this.warehouse_id;
			data.order_classify = this.order_classify;
			data.warehouse_name = this.$refs.warehouseInfo.getData().data.warehouse_name;
			data.batch_id = this.batch_id;
			this.$emit('resolve', data);
		}
	}
}
</script>